import { AgentsCreationModal } from './AgentsCreationSection/AgentsCreationModal.section';
import { CreateAgentButtonProps } from './CreateAgentButton.decl';

import { Dropdown, DropdownButton, Menu, MenuItem } from '@aircall/tractor-v2';
import { useToggle } from '@hooks/useToggle/useToggle';
import { useTranslation } from 'react-i18next';

export function CreateAgentButton({
  onCreateMultipleUsers,
  onCreationCompleted,
  onCreationSubmited,
  size = 'regular',
}: CreateAgentButtonProps) {
  const { t } = useTranslation();
  const [isModalOpen, toggleModal] = useToggle();

  return (
    <>
      <Dropdown
        trigger={
          <DropdownButton size={size} mode='fill' variant='primary' data-test='create-user-trigger'>
            {t('users.create_one_or_multiple')}
          </DropdownButton>
        }
        side='bottom'
        align='end'
      >
        <Menu>
          <MenuItem
            itemKey='create-one'
            data-test='create-user-button'
            data-tracking='user-creation-process-started'
            onClick={toggleModal}
          >
            {t('users.create_one')}
          </MenuItem>
          <MenuItem
            itemKey='create-multiple'
            data-test='create-multiple-users-button'
            onClick={onCreateMultipleUsers}
          >
            {t('users.create_multiple')}
          </MenuItem>
        </Menu>
      </Dropdown>

      <AgentsCreationModal
        isOpen={isModalOpen}
        onClose={toggleModal}
        onCreationCompleted={onCreationCompleted}
        onCreationSubmited={onCreationSubmited}
      />
    </>
  );
}
